/* eslint-disable unicorn/no-useless-promise-resolve-reject */
/* eslint-disable promise/no-return-wrap */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unicorn/prefer-ternary */
/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable unicorn/no-null */
/* eslint-disable unicorn/prevent-abbreviations */
/*
This file is copied from the @atabix/core package.
It should be replaced with the original file from the package.
But the original triggers TypeScript errors which are not yet resolved for this projects setup.
*/
import { aObjectToFormdata } from '@atabix/core/src/http/aObjectToFormdata';
import { AString } from '@atabix/core/src/support/AString';
import { AUrl } from '@atabix/core/src/support/AUrl';
import Axios from 'axios';
export class ACustomClient {
    static { this.isDebug = false; }
    constructor(options = {}) {
        this.isWithErrorResolver = true;
        this.$options = {
            baseUrl: '',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            headerResolver: () => ({}),
            baseUrlResolver: () => this.$options.baseUrl,
            errorResolver: (error, _request) => {
                const logPrefix = '[NETWORK-RESPONSE]';
                ACustomClient.debug(`${logPrefix} ${JSON.stringify(error)} ${error}`);
                return Promise.reject(error);
            },
            responseResolver: (response) => Promise.resolve(response),
        };
        this.$options = { ...this.$options, ...options };
    }
    addHeaders(additionalHeaders) {
        this.$options.headers = {
            ...this.$options.headers,
            ...additionalHeaders,
        };
        return this;
    }
    withoutErrorResolver() {
        this.isWithErrorResolver = false;
        return this;
    }
    async call(method, url, payload, headers = {}) {
        const client = this.createAxios(method, url, payload, headers);
        const logRequestLine = `${method.toUpperCase()} ${decodeURIComponent(String(client.defaults.url))}`;
        return client
            .request(client.defaults)
            .then(async (response) => {
            const logPrefix = '[NETWORK-RESPONSE]';
            ACustomClient.debug(`${logPrefix} HTTP ${response.status} ${logRequestLine}`);
            if (this.$options.responseResolver) {
                return this.$options.responseResolver(response);
            }
            return Promise.resolve(response);
        })
            .catch(async (error) => {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // this is what we're used to
            }
            else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                ACustomClient.debug(error.request);
            }
            else {
                // Something happened in setting up the request that triggered an Error
                ACustomClient.debug('Error', error.message);
            }
            if (this.$options.errorResolver && this.isWithErrorResolver) {
                return this.$options.errorResolver(error, this, {
                    method,
                    url,
                    payload,
                    headers,
                });
            }
            // eslint-disable-next-line unicorn/no-useless-promise-resolve-reject
            return Promise.reject(error);
        })
            .finally(() => {
            this.isWithErrorResolver = true;
        });
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    callGet(url, payload = {}) {
        return this.call('GET', url, payload);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    callPost(url, payload) {
        return this.call('POST', url, payload);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    callPatch(url, payload) {
        return this.call('PATCH', url, payload);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    callPut(url, payload) {
        return this.call('PUT', url, payload);
    }
    callDelete(url, payload) {
        return this.call('DELETE', url, payload);
    }
    getResolvedUrl(url = '') {
        if (AUrl.isValid(url)) {
            return url;
        }
        let baseUrl = this.$options?.baseUrlResolver() || '';
        baseUrl = baseUrl ? AString.trim(baseUrl, '/') : '';
        return url ? `${baseUrl}/${AString.ltrim(url, '/')}` : baseUrl;
    }
    getResolvedHeaders(headers = {}) {
        // const combinedHeaders = {
        //   ...this.$options.headers,
        //   ...this.$options.headerResolver(),
        //   ...headers,
        // };
        const combinedHeaders = {
            ...this.$options.headerResolver(),
            ...this.$options.headers,
            ...headers,
        };
        // Filter any empty headers out of the request.
        Object.keys(combinedHeaders).forEach((headerKey) => {
            if (!combinedHeaders[headerKey]) {
                delete combinedHeaders[headerKey];
            }
        });
        return combinedHeaders;
    }
    get baseUrl() {
        return this.$options.baseUrl || '';
    }
    set baseUrl(url) {
        this.$options.baseUrl = url;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setHeaderResolver(resolver) {
        return {};
    }
    static debug(...messages) {
        if (ACustomClient.isDebug) {
            messages.forEach((message) => {
                console.log(`(VUE-CORE) ${message}`);
            });
        }
    }
    payloadHasFile(payload) {
        let hasFile = false;
        const keys = Object.keys(payload);
        keys.forEach((property) => {
            if (payload[property] !== undefined &&
                payload[property] !== null &&
                payload[property].name !== undefined &&
                payload[property].lastModified !== undefined &&
                payload[property].size !== undefined) {
                hasFile = true;
            }
        });
        return hasFile;
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    createAxios(method, url, payload, headers = {}) {
        const options = {};
        options.method = method;
        options.url = this.getResolvedUrl(url);
        options.headers = this.getResolvedHeaders(headers);
        if (['POST', 'PUT', 'PATCH'].includes(options.method)) {
            options.data = this.payloadHasFile(payload) ? aObjectToFormdata(payload) : payload;
        }
        if (['GET', 'DELETE'].includes(options.method)) {
            options.params = payload;
        }
        const logPrefix = '[NETWORK-REQUEST]';
        const logRequestLine = `${method.toUpperCase()} ${decodeURIComponent(options.url)}`;
        ACustomClient.debug(`${logPrefix} ${logRequestLine}`);
        return Axios.create(options);
    }
}
